import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { AgGridTableWrapper } from '../utils';
import { ColAction, IoniconsOutline, ListData } from '@pt/pt-models';
import { TranslateService } from '@ngx-translate/core';
import { ColDef, GridOptions, SelectionChangedEvent } from 'ag-grid-community';
import { User } from 'it/primatoo/openapi/api/org/schemas/user/User';
import {  PermissionManager } from '@pt/pt-core';

@Component({
  selector: 'pt-impersonation-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">
        {{ 'TITLE.IMPERSONATE_DIALOG' | translate }}
      </h4>
    </div>

    <div class="modal-body" style="height: 300px">
      <ag-grid-angular
        *ngIf="gridOptions()"
        [statusBar]="statusBar"
        [loadingOverlayComponent]="loadingOverlayComponent"
        [loadingOverlayComponentParams]="loadingOverlayComponentParams"
        class="ag-theme-balham w-100 h-100"
        (filterChanged)="onFilterChanged()"
        [gridOptions]="gridOptions()"
        [rowSelection]="'single'"
        (selectionChanged)="checkBoxChanged($event)"
      >
      </ag-grid-angular>

      <ng-template #actionCol let-node>
        <pt-icon
          [key]="actionIcon"
          *ngIf="node.row?.system"
          class="text-link"
          container="body"
          ngbTooltip="{{ 'TOOLTIP.SYSTEM' | translate }}"
        >
        </pt-icon>
        <pt-icon
          [key]="actionIcon"
          *ngIf="node.row?.admin"
          class="text-link"
          container="body"
          ngbTooltip="{{ 'TOOLTIP.ADMIN' | translate }}"
        >
        </pt-icon>
      </ng-template>
    </div>

    <div class="modal-footer">
      <div class="d-flex gap-2 justify-content-end">
        <button
          (click)="continueAsSystem.emit(true)"
          data-testid="btn-as-system"
          class="btn btn-sm btn-outline-primary me-2"
        >
          {{ 'BUTTON.CONTINUE_AS_SYSTEM' | translate }}
        </button>

        <pt-button-with-loader
          [loading]="loading"
          [disabled]="!selectedUser || loading"
          [cssClass]="'btn btn-primary btn-sm'"
          [label]="'BUTTON.IMPERSONATE' | translate"
          (buttonWithLoaderClick)="impersonateUser.emit(selectedUser)"
        ></pt-button-with-loader>

        <button
          ngbAutofocus
          type="button"
          class="btn btn-outline-secondary btn-sm"
          [disabled]="loading"
          (click)="cancel.emit()"
        >
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .modal-body {
        min-height: 350px;
      }

      ag-grid-angular {
        height: 100%;
      }
    `,
  ],
})
export class ImpersonationDialogComponent
  extends AgGridTableWrapper<User>
  implements OnInit, OnChanges
{
  @ViewChild('actionCol', { static: true }) actionCol: TemplateRef<unknown>;

  @Input() data: ListData<User> = null;
  @Input() loading: boolean;

  @Output() impersonateUser = new EventEmitter<User>();
  @Output() continueAsSystem: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() cancel = new EventEmitter<User>();

  selectedUser: User;

  actionIcon = IoniconsOutline.userCircle;

  constructor(
    public translateService: TranslateService,
    public permissionManager: PermissionManager
  ) {
    super(translateService, permissionManager);
  }

  ngOnInit(): void {
    this.onChangeData(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.onChangeData(changes.data.currentValue);
    }
  }

  createColumnDefs(): ColDef[] {
    return [];
  }

  createGridOptions(columnDefs: ColDef[], rowData: User[]): GridOptions {
    return {
      ...this.defaultGridOptions(null, columnDefs, rowData),
      rowSelection: 'single',
    };
  }

  checkBoxChanged(event: SelectionChangedEvent) {
    this.selectedUser = event.api.getSelectedRows()[0];
  }

  // checkBoxChanged() {
  //   if (!this.gridApi || this.gridApi.getSelectedRows().length === 0) {
  //     return;
  //   }
  //   this.selectedUser = this.gridApi.getSelectedRows()[0];
  // }

  clickActions(action: ColAction, row: User) {
    //empty
  }

  colActionsTemplate(): TemplateRef<unknown> {
    return this.actionCol;
  }
}
